import { Pipe, PipeTransform } from '@angular/core';

export interface DroplistOption {
  id: number;
  parent_id: number;
  name: string;
  value: string;
  meta_data_id: number;
  user_id: number;
  crm_option_id: number | null;
  hide?: number;
}

export interface FlattenedDroplistOption extends DroplistOption {
  level: number;
}

interface TreeNode extends FlattenedDroplistOption {
  children: TreeNode[];
}

@Pipe({
  name: 'flattenOptions'
})
export class FlattenOptionsPipe implements PipeTransform {
  transform(options: DroplistOption[]): FlattenedDroplistOption[] {
    const map = new Map<number, TreeNode>();
    const roots: TreeNode[] = [];

    // Initialize map
    for (const item of options) {
      map.set(item.id, { ...item, level: 0, children: [] });
    }

    // Build tree
    for (const item of options) {
      const node = map.get(item.id)!;
      if (item.parent_id && map.has(item.parent_id)) {
        const parent = map.get(item.parent_id)!;
        node.level = parent.level + 1;
        parent.children.push(node);
      } else {
        roots.push(node);
      }
    }

    // Flatten tree
    const result: FlattenedDroplistOption[] = [];
    const flatten = (nodes: TreeNode[]) => {
      for (const node of nodes) {
        const { children, ...rest } = node;
        result.push(rest);
        if (children.length > 0) {
          flatten(children);
        }
      }
    };

    flatten(roots);
    return result;
  }
}
